export const Bio = {
  name: "Dhruv Saboo",
  roles: [
    "Backend Developer",
    "Software Engineer",
    "DSA Enthusiast",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/dhruvsaboo1805",
  resume:
    "https://drive.google.com/file/d/1b6hTKYQAy_kRZxY_DyNEKShfiT2dM50G/view?usp=drivesdk",
  linkedin: "https://www.linkedin.com/in/dhruvsaboo1805",
  insta: "https://www.instagram.com/dev_with_dhruv/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: "/images/skills/react.svg",
      },
      {
        name: "Redux",
        image: "/images/skills/redux2.svg",
      },
      {
        name: "HTML",
        image: "/images/skills/html5.png",
      },
      {
        name: "CSS",
        image: "/images/skills/css3.png",
      },
      {
        name: "Tailwind",
        image: "/images/skills/tailwind.svg",
      },
      {
        name: "JavaScript",
        image: "/images/skills/javascript.png",
      },
      {
        name: "Bootstrap",
        image: "/images/skills/bootstrap.svg",
      },
      {
        name: "Flutter",
        image: "/images/skills/flutter.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "/images/skills/java.svg",
      },
      {
        name: "Spring Boot",
        image: "/images/skills/springboot.svg",
      },
      {
        name: "Node Js",
        image: "/images/skills/nodejs.svg",
      },
      {
        name: "Express Js",
        image: "/images/skills/expressjs.svg",
      },
      {
        name: "MySQL",
        image: "/images/skills/mysql.svg",
      },
      {
        name: "MongoDB",
        image: "/images/skills/mongodb.svg",
      },
      {
        name: "Firebase",
        image: "/images/skills/firebase.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "/images/skills/git.svg",
      },
      {
        name: "GitHub",
        image: "/images/skills/github.png",
      },
      {
        name: "Vercel",
        image: "/images/skills/vercel.svg",
      },
      {
        name: "Netlify",
        image: "/images/skills/netlify.svg",
      },
      {
        name: "VS Code",
        image: "/images/skills/vscode.svg",
      },
      {
        name: "Postman",
        image: "/images/skills/postman.svg",
      },
      {
        name: "Figma",
        image: "/images/skills/figma.svg",
      },
      {
        name: "Docker",
        image: "/images/skills/docker.svg",
      },
    ],
  },
];


export const experiences = [
  {
    id: 0,
    img: "/images/skills/tcs.svg",
    role: "Software Engineer",
    company: "Tata Consultancy Services (TCS)",
    date: "Aug 2025 - Present",
    desc: "Working as a Software Engineer at TCS on the Quartz Compliance project for a Swiss client. • End-to-End Development: Built the application and ledger system from scratch, managing 10+ microservices and third-party integrations. • Ledger Architecture: Engineered a comprehensive financial ledger system handling complex transaction flows across internal and external bank accounts. • High-Volume Scaling: Scaled application traffic from 10 to 1000+ daily requests using load balancers and server optimizations to ensure zero downtime. • System Gateway Optimization: Developed a critical middleware bridge to intercept, scan, and process heavy data loads before securely routing them to downstream systems. • CI/CD Pipeline Management: Streamlined deployment and managed UAT and Production environments using Jenkins and Docker containers. • 🏆 Award: Won the 'Best Performer of Q4 2025' award for outstanding contributions, technical delivery, and project execution.",
    skills: [
      "Java",
      "Spring Boot",
      "Docker",
      "Jenkins",
      "Microservices",
      "System Design",
      "Load Balancing",
      "JFrog",
    ],
  },
  {
    id: 1,
    img: "/images/companies/tryidol.png",
    role: "Web Developer Intern",
    company: "Tryidol Technologies",
    date: "May 2024 - Present",
    desc: "Working on CRM (Customer RelationShip Management) based Projects ",
    skills: [
      "JavaScript",
      "CSS",
      "React Js",
      "Node Js",
      "Express",
      "Mongo DB",
    ],
  },
  {
    id: 2,
    img: "/images/companies/nexus.png",
    role: "Web Developer Intern",
    company: "Nexus Info",
    date: "April 2024 - May 2024",
    desc: "Working on the full Stack Projects of MERN",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "HTML",
      "CSS",
      "JavaScript",
      "Express",
      "Mongo DB",
    ],
  },
  {
    id: 3,
    img: "/images/companies/girlscript.png",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "April 2024 - Present",
    desc: "Contributing to different open-source projects and learn from industry experts",
  },
];

export const education = [
  {
    id: 0,
    img: "/images/education/lncts.png",
    school: "Lakshmi Narain College Of Technology & Science , Bhopal",
    date: "Oct 2021 - July 2025",
    grade: "8.75 C.G.P.A ( Batch Rank 4 )",
    desc: "I completed my Bachelor's degree in Computer Science and Engineering at Lakshmi Narain College Of Technology & Science, Bhopal. I took courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. • Activities and societies: UXcelerate Club Member: Actively contributed to the enhancement of design skills in over 500 students through engaging activities. • Event Anchor & Host: Took an active role as an anchor in various college events, including fests and cultural functions. • Founder & Lead of Tech Club: Responsible for building a community of tech enthusiasts from the ground up and organized various coding contests.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "/images/education/mvm_shahdol.png",
    school: "Maharshi Vidya Mandir, Shahdol",
    date: "Apr 2019 - Apr 2021",
    grade: "95.6%",
    desc: "I completed my class 12 high school education at Maharshi Vidya Mandir, Shahdol, where I studied Science Stream subjects.",
    degree: "CBSE (XII), Science",
  },
  {
    id: 2,
    img: "/images/education/good_shepherd.png",
    school: "Good Shepherd Covent Sr. Sec. School , Shahdol",
    date: "Apr 2006 - Apr 2019",
    grade: "89.4%",
    desc: "I completed my class 10 education at Good Shepherd Covent Sr. Sec. School , Shahdol, where I studied the course from class nursery to class 10th",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 100,
    title: "Auth Microservice - Spring Boot",
    date: "Oct 2025 - Feb 2026",
    description:
      "A production-grade Authentication Microservice built with Spring Boot. Fully containerized with Docker for seamless deployment. Implements JWT-based authentication, role-based access control (RBAC), OAuth2 integration, and secure token refresh mechanisms. Docker Compose setup for running the entire stack locally.",
    image: "/images/projects/auth_microservice.png",
    tags: ["Java", "Spring Boot", "JWT", "Spring Security", "Microservices", "Docker", "MySQL"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/Auth_Microservice_SpringBoot",
    webapp: "https://github.com/dhruvsaboo1805/Auth_Microservice_SpringBoot",
  },
  {
    id: 101,
    title: "AirBnb Backend - Spring Boot",
    date: "Dec 2025",
    description:
      "Full-featured AirBnb clone backend built with Spring Boot. Includes property listing management, booking system with availability checks, user authentication, pricing engine, and REST APIs for a complete rental marketplace.",
    image: "/images/projects/airbnb.png",
    tags: ["Java", "Spring Boot", "Spring Security", "JPA", "MySQL", "REST API"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/AirBnb-Backend-SpringBoot",
    webapp: "https://github.com/dhruvsaboo1805/AirBnb-Backend-SpringBoot",
  },
  {
    id: 102,
    title: "Uber Backend - WebSockets",
    date: "Dec 2024",
    description:
      "Real-time Uber-like ride-hailing backend powered by WebSockets for live driver-rider communication. Features real-time location tracking, ride matching algorithm, fare calculation, and push notifications using STOMP protocol over WebSockets.",
    image: "/images/projects/uber_ws.png",
    tags: ["Java", "Spring Boot", "WebSockets", "STOMP", "MySQL", "Real-time"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/Uber-Backend-WebSockets",
    webapp: "https://github.com/dhruvsaboo1805/Uber-Backend-WebSockets",
  },
  {
    id: 103,
    title: "Uber Backend - Spring Boot",
    date: "Nov 2025 - Dec 2024",
    description:
      "Comprehensive Uber ride-hailing REST backend with Spring Boot. Implements driver-rider matching, ride lifecycle management (request → accept → ongoing → complete), payment integration, rating system, and geolocation-based driver discovery.",
    image: "/images/projects/uber_sb.png",
    tags: ["Java", "Spring Boot", "Spring JPA", "MySQL", "REST API", "Geolocation"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/Uber_Backend_SpringBoot",
    webapp: "https://github.com/dhruvsaboo1805/Uber_Backend_SpringBoot",
  },
  {
    id: 104,
    title: "Payment Wallet - SAGA Pattern",
    date: "Sep 2025 - Oct 2025",
    description:
      "Distributed payment wallet system implementing the SAGA pattern for distributed transactions. Features sharded database architecture for horizontal scalability, eventual consistency guarantees, compensating transactions, and idempotent API design.",
    image: "/images/projects/payment_wallet.png",
    tags: ["Java", "Spring Boot", "SAGA Pattern", "Sharding", "Distributed Systems", "MySQL"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/Payment_Wallet_Sharded_DB_SAGA_Pattern",
    webapp: "https://github.com/dhruvsaboo1805/Payment_Wallet_Sharded_DB_SAGA_Pattern",
  },
  {
    id: 105,
    title: "Electricity Management - Spring Boot",
    date: "Oct 2025",
    description:
      "Spring Boot based electricity management system for managing consumer connections, meter readings, bill generation, and payment tracking. Features admin dashboard APIs, automated billing cycles, and consumption analytics.",
    image: "/images/projects/electricity.png",
    tags: ["Java", "Spring Boot", "JPA", "MySQL", "REST API"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/ElectricityManagement_SpringBoot",
    webapp: "https://github.com/dhruvsaboo1805/ElectricityManagement_SpringBoot",
  },
  {
    id: 106,
    title: "Spring Boot Quora App",
    date: "Aug 2025 - Sep 2025",
    description:
      "A Quora-like Q&A platform backend with Spring Boot. Features question posting, answer submission, upvote/downvote system, user follow/unfollow, topic-based filtering, full-text search, and notification system.",
    image: "/images/projects/quora.svg",
    tags: ["Java", "Spring Boot", "Spring Security", "JPA", "MySQL", "REST API"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/Spring-Boot-Quora-App",
    webapp: "https://github.com/dhruvsaboo1805/Spring-Boot-Quora-App",
  },
  {
    id: 107,
    title: "Ecommerce - Spring Boot",
    date: "Jun 2025 - Jul 2025",
    description:
      "Full-featured ecommerce backend with Spring Boot covering product catalog management, shopping cart, order management, payment gateway integration, inventory tracking, and seller/buyer roles with JWT authentication.",
    image: "/images/projects/ecommerce.png",
    tags: ["Java", "Spring Boot", "JPA", "MySQL", "JWT", "REST API"],
    category: "backend",
    github: "https://github.com/dhruvsaboo1805/Ecommerce-Springboot",
    webapp: "https://github.com/dhruvsaboo1805/Ecommerce-Springboot",
  },

  {
    id: 9,
    title: "My Air Visual",
    date: "March 2024 - April 2024",
    description:
      "My Air Visual is a web application designed to streamline the information from several sources and lets you see and sort the data in different ways.The website aims to help people understand air quality and make informed choices to support cleaner air efforts.We have also developed a server from which all resources have been distributed like discord Bot and Arduino IOT Devices also.",
    image: "/images/projects/air_visual.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "Ardunio",
      "Blynk",
      "Vercel",
      "Render",
    ],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/AIR_QUALITY_MANAGEMENT_SOFTWARES/tree/main",
    webapp: "https://github.com/dhruvsaboo1805/AIR_QUALITY_MANAGEMENT_SOFTWARES/tree/main",
    member: [
      {
        name: "Dhruv Saboo",
        img: "/images/members/dhruv.png",
        linkedin: "https://www.linkedin.com/in/dhruvsaboo1805",
      },
      {
        name: "Amaan Hussain",
        img: "https://ui-avatars.com/api/?name=Amaan+Hussain&background=0D8ABC&color=fff&size=200&bold=true",
        linkedin: "https://www.linkedin.com/in/hussainamaan87",
      },
      {
        name: "Aryan Gupta",
        img: "https://ui-avatars.com/api/?name=Aryan+Gupta&background=6B48FF&color=fff&size=200&bold=true",
        linkedin: "https://www.linkedin.com/in/agaryan",
      },
      {
        name: "Akanksha Kumari",
        img: "https://ui-avatars.com/api/?name=Akanksha+Kumari&background=E91E8C&color=fff&size=200&bold=true",
        linkedin: "https://www.linkedin.com/in/akanksha314",
      },
    ],
  },
  {
    id: 0,
    title: "Techy Software Website",
    date: "Apr 2023 - May 2023",
    description:
      "Developed a full-stack web application , this project showcases a comprehensive React application featuring various sections such as Home, About Us, Services, Contact Us, and more. It also integrates email sending functionality via EmailJS and implements smooth navigation and scrolling animations for an enhanced user experience.",
    image: "/images/projects/techy_software.png",
    tags: ["React Js", "Email Js", "Redux", "GSAP Animations"],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/3-project-nexus",
    webapp: "https://3-project-nexus-techy-software.vercel.app/",
  },
  {
    id: 1,
    title: "Food Delivery WebApp with Authentication ",
    date: "Jan 2024 - Feb 2024",
    description:
      "This food delivery web application is designed to provide users with a convenient and seamless experience when ordering food online. Built using React.js and Firebase authentication, the app offers a range of features to enhance the user experience and streamline the ordering process.",
    image: "/images/projects/food_delivery.png",
    tags: [
      "React Js",
      "FireBase",
    ],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/2-project-nexus",
    webapp: "https://2-project-nexus.vercel.app/",
  },
  {
    id: 2,
    title: "Shopping Cart Web Application",
    date: "Nov 2023",
    description:
      "This project enables us to select the objects which we have to buy and take them into cart section for furthur process",
    image: "/images/projects/shopping_cart.png",
    tags: ["React Js", "Tailwind-CSS"],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/shopping_Cart_WebApp",
    webapp: "https://shopping-cart-web-app.vercel.app/",
  },
  {
    id: 3,
    title: "Discord Bot",
    date: "Feb 2024 - March 2024",
    description:
      "My Discord bot serves as a convenient tool for calculating Air Quality Index (AQI) values for cities specified by users. By simply entering the name of a city, users can receive comprehensive data on AQI levels, including information such as pollutant concentrations and health implications. Furthermore, the bot provides tailored health advice based on the AQI value, offering insights into how current air quality may impact well-being. This feature enhances user awareness of environmental conditions and promotes healthier lifestyle choices in response to varying air quality levels.",
    image: "/images/projects/discord_bot.png",
    tags: ["AQI Api (from CPCB)", "Node js", "Express Js", "Mongo DB", "Discord API"],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/Discord_Bot",
    webapp: "https://github.com/dhruvsaboo1805/Discord_Bot",
  },
  {
    id: 10,
    title: "Random GIF Generator",
    date: "Dec 2023",
    description:
      "In this Project we can generate random gifs and also can generate the gifs according to user need.",
    image: "/images/projects/random_gif.png",
    tags: ["React", "GIF API"],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/Random_Gif_Generator_React?tab=readme-ov-file",
    webapp: "https://65f05ff36b9f6514867b8658--dulcet-raindrop-bdc12a.netlify.app/",
  },
  {
    id: 5,
    title: "Weather WebApp",
    date: "Jun 2023",
    description:
      "In this Project we can seek the weather according the location given and by default your curre=nt loication weather will be seen with humidity precepetation and clouds data.",
    image: "/images/projects/weather_app.png",
    tags: ["HTML", "Tailwind-CSS", "Javascript", "Open-Weather-Api"],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/Weather_App",
    webapp: "https://65d8978e97da63f30890e0b2--elegant-concha-cd5cd4.netlify.app/",
  },
  {
    id: 6,
    title: "Discord Clone",
    date: "July 2023",
    description:
      "A simple clone of Discord website.",
    image: "/images/projects/discord_clone.png",
    tags: ["HTML", "Tailwind-CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/dhruvsaboo1805/Discord_Clone",
    webapp: "https://discord-clone-one-peach.vercel.app/",
  },

  {
    id: 8,
    title: "IOT based Smart Home App",
    date: "March 2023 - April 2023",
    description:
      "This is the Mobile App in Flutter which is connected through the IOT sensor and from this app we can switch on/off the devices connected.",
    image: "/images/projects/smart_home.png",
    tags: ["Flutter", "IOT", "Sensors", "Firebase"],
    category: "android app",
    github: "https://github.com/dhruvsaboo1805/Smart_Home_App_Firebase_Arduino",
    webapp: "https://drive.google.com/file/d/1ucbbDAf-GHT0W3wzcR6dA2SzrVvNLf1V/view",
    member: [
      {
        name: "Dhruv Saboo",
        img: "/images/members/dhruv.png",
        linkedin: "https://www.linkedin.com/in/dhruvsaboo1805",
      },
      {
        name: "Amaan Hussain",
        img: "https://ui-avatars.com/api/?name=Amaan+Hussain&background=0D8ABC&color=fff&size=200&bold=true",
        linkedin: "https://www.linkedin.com/in/hussainamaan87",
      },
    ],
  },
  {
    id: 9,
    title: "KIsaan Saathi App",
    date: "Oct 2023 - Nov 2023",
    description:
      " ’Kisaan Saathi ’ application offers comprehensive information on a wide range of crops, including planting, harvesting, and maintenance details. Small-scale farmers can access real-time data on market trends, commodity prices, and demand forecasts, helping them stay informed about the latest developments.Users will have access to valuable insights into government schemes and current regulations related to agriculture, ensuring they stay compliant with the latest policies. Our application provides up-to-date market news and in-depth analysis, enabling farmers to make informed decisions on crop choices and pricing negotiations.",
    image: "/images/projects/kisaan_saathi.png",
    tags: ["Flutter", "Firebase"],
    category: "android app",
    github: "https://github.com/dhruvsaboo1805/NIT_BHOPAL_VERSION_BETA_6.0",
    webapp: "https://drive.google.com/file/d/1976528p6UXQ5CILj92sA0AJunV5sjm3E/view",
    member: [
      {
        name: "Dhruv Saboo",
        img: "/images/members/dhruv.png",
        linkedin: "https://www.linkedin.com/in/dhruvsaboo1805",
      },
      {
        name: "Amaan Hussain",
        img: "https://ui-avatars.com/api/?name=Amaan+Hussain&background=0D8ABC&color=fff&size=200&bold=true",
        linkedin: "https://www.linkedin.com/in/hussainamaan87",
      },
      {
        name: "Aryan Gupta",
        img: "https://ui-avatars.com/api/?name=Aryan+Gupta&background=6B48FF&color=fff&size=200&bold=true",
        linkedin: "https://www.linkedin.com/in/agaryan",
      },
      {
        name: "Aviral Gupta",
        img: "https://ui-avatars.com/api/?name=Aviral+Gupta&background=FF6B35&color=fff&size=200&bold=true",
        linkedin: "https://www.linkedin.com/in/guptaaviral",
      },
    ],
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
